"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../Theme");

var _Message = _interopRequireDefault(require("../Message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0.25em;\n  font-size: 0.75em;\n  line-height: 1;\n  height: 1em;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: table-cell;\n  width: 100%;\n  height: 40px;\n  padding: ", ";\n  color: ", ";\n  line-height: 30px;\n  vertical-align: middle;\n  box-sizing: border-box;\n  font-size: 1em;\n  border: ", ";\n  background: ", ";\n  transition: border ease 0.2s;\n  box-shadow: none;\n\n  ::placeholder {\n    color: ", ";\n    opacity: 1;\n  }\n\n  :focus {\n    outline: ", ";\n    outline-offset: ", ";\n  }\n\n  :disabled {\n    cursor: not-allowed;\n  }\n\n  :invalid:not(:focus) {\n    border-color: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 0.25em;\n  flex: 1 0 auto;\n  font-size: 0.75em;\n  letter-spacing: 0.5px;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n  display: inline-flex;\n  flex-flow: column nowrap;\n  align-items: flex-start;\n  cursor: ", ";\n  opacity: ", ";\n\n  ::after {\n    display: ", ";\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 1.125em;\n    height: ", ";\n    background: ", ";\n    background-image: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = _styledComponents.default.label(_templateObject(), function (props) {
  return props.disabled ? 'not-allowed' : 'auto';
}, function (props) {
  return props.disabled ? '0.35' : '1';
}, function (props) {
  return props.underlined ? 'block' : 'none';
}, function (props) {
  return props.autoFocus || props.focused || props.error && props.dirty ? '2px' : '1px';
}, function (props) {
  return props.autoFocus || props.focused ? 'transparent' : props.error && props.dirty && (!props.autoFocus || !props.focused) ? props.theme.colorError : props.theme.colorTextPrimary;
}, function (props) {
  return props.autoFocus || props.focused ? "repeating-linear-gradient(\n        to right,\n        ".concat(props.theme.colorTextPrimary, ",\n        ").concat(props.theme.colorTextPrimary, " 2px,\n        transparent 0,\n        transparent 4px\n      )") : 'none';
});

var LabelText = _styledComponents.default.span(_templateObject2(), function (props) {
  return props.theme.colorTextPrimary;
});

var Input = _styledComponents.default.input(_templateObject3(), function (props) {
  return props.underlined ? '0' : '0 8px';
}, function (props) {
  return props.theme.colorTextPrimary;
}, function (props) {
  return props.underlined ? 'none' : props.error && props.dirty && (!props.autoFocus || !props.focused) ? "1px solid ".concat(props.theme.colorError) : "1px solid ".concat(props.theme.colorTextPrimary);
}, function (props) {
  return props.underlined ? 'none' : props.theme.colorBackgroundLight;
}, function (props) {
  return props.theme.colorTextSecondary;
}, function (props) {
  return props.underlined ? 'none' : props.theme.focusIndicator;
}, function (props) {
  return props.theme.focusIndicatorOffset;
}, function (props) {
  return props.error && props.dirty && (!props.autoFocus || !props.focused) ? props.theme.colorError : props.theme.colorTextPrimary;
});

var Error = _styledComponents.default.div(_templateObject4());

var InputText = /*#__PURE__*/function (_Component) {
  _inherits(InputText, _Component);

  function InputText(props) {
    var _this;

    _classCallCheck(this, InputText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputText).call(this, props));
    _this.input = _react.default.createRef();
    _this.fallbackError = 'Value is unexpected.';
    var validationErrors = Object.assign({
      patternMismatch: 'Value is unexpected.',
      rangeOverflow: 'Value is too large.',
      rangeUnderflow: 'Value is too small.',
      stepMismatch: 'This is an invalid step interval value.',
      tooLong: 'Value is too long.',
      tooShort: 'Value is too short.',
      typeMismatch: 'Value is not the correct format.',
      valueMissing: 'This field is required.',
      fallback: _this.fallbackError
    }, props.validationErrors);
    var hasError = props.error && props.error.length;
    _this.state = {
      isValid: !hasError,
      error: hasError ? props.error : null,
      // error message string
      dirty: hasError,
      validationErrors: validationErrors
    };
    _this.errorId = (0, _uniqueId.default)('hw-input-text-error');
    _this.checkValidity = _this.checkValidity.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this lets the parent component fire off the validation whenever it wants to
      // - approach taken from https://stackoverflow.com/questions/37949981/call-child-method-from-parent/45582558#45582558
      this.props.getValidator(this.checkValidity.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.getValidator(null);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.error !== this.props.error) {
        // if error is truthy, fire off an error, otherwise recheck it
        if (this.props.error && this.props.error.length) {
          this.setState({
            isValid: false,
            error: this.props.error,
            dirty: true
          });
        } else {
          this.setState({
            isValid: true,
            error: this.props.error
          }, function () {
            return _this2.checkValidity(false);
          });
        }
      }
    }
  }, {
    key: "checkValidity",
    value: function checkValidity() {
      var calledExternally = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _this$props = this.props,
          error = _this$props.error,
          validators = _this$props.validators,
          onValid = _this$props.onValid,
          onInvalid = _this$props.onInvalid;
      var validationErrors = this.state.validationErrors;
      var fallbackError = this.fallbackError;
      var input = this.input.current;
      var validity = input && input.validity;
      var isValid = !error;
      var errorType = error ? 'supplied' : null;
      var errorMessage = error || null; // if there's not an error yet AND the field is dirty AND we have browser support...

      if (isValid && (this.state.dirty || calledExternally) && validity) {
        isValid = validity.valid;
      } // if we're valid so far, run the custom validation


      if (isValid && validators) {
        Object.keys(validators).forEach(function (key) {
          // the "!!" gets us a boolean, regardless of what comes back
          var customIsValid = !!validators[key](input.value);
          isValid = isValid && customIsValid;

          if (!customIsValid) {
            errorType = key;
            errorMessage = validationErrors[key] || validationErrors['fallback'] || fallbackError;
          }
        });
      } // when there's an error


      if (!isValid) {
        // find the right error message
        if (!errorMessage) {
          // try to find a known message (via the HTML5 validity API)
          Object.keys(validationErrors).forEach(function (key) {
            if (typeof validity[key] !== 'undefined' && validity[key] === true) {
              errorType = key;
              errorMessage = validationErrors[key];
            }
          }); // if we can't find one, go with the fallback

          if (!errorMessage) {
            errorType = 'unknown';
            errorMessage = validationErrors.fallback;
          }
        } // invalid callback


        onInvalid(input.value, errorType);
      } else {
        // valid callback
        onValid(input.value);
      }

      this.setState({
        isValid: isValid,
        error: errorMessage,
        dirty: true
      });
      return isValid;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(event) {
      this.setState({
        dirty: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      this.checkValidity(false);
      this.setState({
        dirty: true
      });
      this.props.onBlur(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          type = _this$props2.type,
          required = _this$props2.required,
          disabled = _this$props2.disabled,
          readonly = _this$props2.readonly,
          underlined = _this$props2.underlined,
          autoFocus = _this$props2.autoFocus,
          focused = _this$props2.focused,
          label = _this$props2.label,
          error = _this$props2.error,
          theme = _this$props2.theme,
          onBlur = _this$props2.onBlur,
          validationErrors = _this$props2.validationErrors,
          validators = _this$props2.validators,
          onValid = _this$props2.onValid,
          onInvalid = _this$props2.onInvalid,
          getValidator = _this$props2.getValidator,
          otherProps = _objectWithoutProperties(_this$props2, ["className", "placeholder", "type", "required", "disabled", "readonly", "underlined", "autoFocus", "focused", "label", "error", "theme", "onBlur", "validationErrors", "validators", "onValid", "onInvalid", "getValidator"]);

      var _this$state = this.state,
          dirty = _this$state.dirty,
          isValid = _this$state.isValid;
      return _react.default.createElement(Label, {
        disabled: disabled,
        underlined: underlined,
        autoFocus: autoFocus || focused,
        error: error || !isValid,
        dirty: dirty,
        theme: theme
      }, label && _react.default.createElement(LabelText, {
        className: "hw-input-text-label",
        theme: theme
      }, label, required && ' *'), _react.default.createElement(Input, _extends({
        className: (0, _classnames.default)('hw-input-text', "hw-input-text-".concat(type), className),
        ref: this.input,
        type: type,
        placeholder: placeholder,
        required: required,
        disabled: disabled,
        readOnly: readonly,
        "aria-required": required,
        "aria-describedby": this.errorId,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        error: error || !isValid,
        dirty: dirty,
        autoFocus: autoFocus || focused,
        theme: theme,
        underlined: underlined
      }, otherProps)), _react.default.createElement(Error, {
        id: this.errorId,
        className: "hw-input-text-error-container"
      }, !isValid && this.state.dirty && _react.default.createElement(_Message.default, {
        className: (0, _classnames.default)('hw-input-text-error', "".concat(className, "-error")),
        type: "error",
        showIcon: false
      }, this.state.error)));
    }
  }]);

  return InputText;
}(_react.Component);

InputText.propTypes = {
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  type: _propTypes.default.oneOf(['text', 'tel', 'password', 'email', 'search', 'url', 'number', 'date', 'datetime', 'datetime-local', 'month', 'week', 'time']),
  required: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readonly: _propTypes.default.bool,
  underlined: _propTypes.default.bool,
  autoFocus: _propTypes.default.bool,
  label: _propTypes.default.node,
  onBlur: _propTypes.default.func,
  error: _propTypes.default.string,
  validationErrors: _propTypes.default.object,
  validators: _propTypes.default.object,
  onValid: _propTypes.default.func,
  onInvalid: _propTypes.default.func,
  // gives parent access to the validation function, to run at will
  getValidator: _propTypes.default.func,
  theme: _propTypes.default.shape({
    colorBackgroundLight: _propTypes.default.string,
    colorTextPrimary: _propTypes.default.string,
    colorTextSecondary: _propTypes.default.string,
    colorError: _propTypes.default.string,
    focusIndicator: _propTypes.default.string,
    focusIndicatorOffset: _propTypes.default.string
  })
};
InputText.defaultProps = {
  type: 'text',
  onBlur: function onBlur() {},
  onValid: function onValid() {},
  onInvalid: function onInvalid() {},
  getValidator: function getValidator() {},
  theme: _Theme.defaultTheme
};

var _default = (0, _styledComponents.withTheme)(InputText);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/InputText/index.js